import { publicData } from "../../utils/publicData";
export const theoneCommon = {
    getComArgs: {
        getComArgs: function () {
            try {
                return window.TheoneCommon.getComArgs()//获取公参（不需要传参）,返回&拼接字符串
            } catch (error) {
                console.log("getComArgs", error)
                return publicData.getComArgs;
            }
        },
        getComArgsParam: function (param) {
            try {
                return window.TheoneCommon.getComArgsParam(param)//获取公参并参数加密（需要传参）param:json字符串
            } catch (error) {
                console.log("getComArgsParam", error)
                return `${param}&${publicData.getComArgs}`;
            }
        }
    },
    onEvents: function (event, ext) {
        window.TheoneCommon.onEvent(event, JSON.stringify(ext))//埋点-event：事件代码string； ext:json字符串
    },
    networkRequest: {
        //其中conTentType分为application/json和multipart/form-data，
        // data:json字符串
        networkRequestGet: function (url, conTentType, data, callBack) {
            return window.TheoneCommon.networkRequestGet(url, conTentType, JSON.stringify(data), callBack)//网络请求-GET
        },
        networkRequestPost: function (url, conTentType, data, callBack) {
            return window.TheoneCommon.networkRequestPost(url, conTentType, JSON.stringify(data), callBack)//网络请求-POST
        }
    },
    getSwitchs: function (key) {
        return window.TheoneCommon.getSwitch(key)//获取开关（key）-公共服务
    },
    getConfigs: function (key) {
        return window.TheoneCommon.getConfig(key)//获取配置（key）-公共服务
    },
    dialog: function (data, closeDialogCallBack) {
        // data-弹窗展示数据
        // closeDialogCallBack-关闭弹窗回调
        window.TheoneCommon.dialog(JSON.stringify(data), closeDialogCallBack)//弹窗
    },
    jumpWebView: function (url, data, openData) {
        // openData:0 APP内--新的activity
        // openData:1 APP外
        // openData:2 APP内--当前activity
        window.TheoneCommon.jumpWebView(url, data, openData)//跳转h5页面
    },
    jumpAndroidPage: function (url, data) {
        window.TheoneCommon.jumpAndroidPage(url, JSON.stringify(data))//跳转安卓页面
    },
    setKey: function (setKeyData) {
        window.TheoneCommon.setKey(JSON.stringify(setKeyData))//设置数据
    },
    getKey: function (key) {
        return window.TheoneCommon.getKey(key)//获取数据
    },
    isDisplayAndroidComponent: {
        show: function (code) {
            window.TheoneCommon.androidComponentShow(code)//app组件展示-code组件标识
        },
        hide: function (code) {
            window.TheoneCommon.androidComponentHide(code)//app组件隐藏-code组件标识
        }
    },
    appBackPage: function (data) {
        return window.TheoneCommon.appBackPage(JSON.stringify(data))//app返回
    }
}


// WEBPACK FOOTER //
// ./src/plugin/theone/theoneCommon.js